import { Box } from '@cdl/heartbeat-react';

interface Props {
  x: number;
  y: number;
  height: number;
}

export const Ruler2dLine: React.FC<Props> = ({ x, y, height }) => {
  return (
    <Box
      as='rect'
      x={x}
      y={y}
      fill='neutral.300'
      width='0.125rem'
      height={height}
    />
  );
};
